module.exports = __webpack_public_path__ + "wechat-download-tips-fef770a1.png";